<template>
  <v-container grid-list-md fluid ma-0 class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        SoW
      </v-flex>
      <utility-backButton/>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            Editing SoW: {{selectedSoW.Name}}
            <v-spacer/>
            <v-icon @click="cancelEdit" color="pipefishOrange" medium>mdi-close-circle-outline</v-icon>
          </v-card-title>
          <v-card-text style="padding:2px">
            <v-form ref="form" v-model="validation">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 pr-5>
                    <v-text-field
                      label="SoW Name"
                      v-model="selectedSoW.Name"
                      :rules="nameRules"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      label="Active"
                      v-model="selectedSoW.IsActive"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Budgeted Days"
                      v-model="selectedSoW.Days"
                      type="number"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Billing Method"
                      v-model="selectedSoW.BillingMethod"
                      :rules="billingRules"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Cost Calculation"
                      v-model="selectedSoW.CostCalculationMethod"
                      :rules="costRules"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                      <v-textarea
                        outline
                        label="Description"
                        placeholder="e.g. include SoW time period Jan-Jun"
                        color="pipefishGreen"
                        v-model="selectedSoW.Description"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
            <v-btn :loading="showLoading" color="pipefishGreen" @click="saveEdit" :disabled="showLoading || !validation">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12>
          <v-card-title>
            <!-- <span class="title font-weight-bold"> SoW </span> -->
            <v-spacer></v-spacer>
            <div>
              <v-flex xs12>
                <v-select
                  dense
                  hide-details
                  :items="[{text: 'Active', value: false},
                  {text: 'InActive', value: true},
                  {text: 'Both', value: 'Both'}]"
                  label="Filter on"
                  v-model="filterActive"
                >
                </v-select>
              </v-flex>
            </div>
            <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              hide-details
              color="pipefishGreen"
            >
              <template slot="label">
                <span>Search</span>
              </template>
            </v-text-field>
            </div>
            <v-card-actions>
              <v-spacer/>
              <v-btn  left color="pipefishGreen" @click="addStatement">Add</v-btn>
            </v-card-actions>
          </v-card-title>
          Total Shown: {{displayStatements.length}}
          <v-data-table
            v-if="practices != null"
            :headers="headers"
            :items="displayStatements"
            :search="search"
            sort-icon="mdi-menu-down"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{props.item.Name}}</td>
              <td>{{props.item.Days}}</td>
              <td>{{getCount(props.item)}}</td>
              <td>{{props.item.Description}}</td>
              <td>{{props.item.BillingMethod}}</td>
              <td>{{props.item.CostCalculationMethod}}</td>
              <td>{{props.item.IsActive ? "active" : "inactive"}}</td>
              <td class="text-xs-centre">
                <utility-editButton @edit="editStatement(props.item)"/>&nbsp;
                <v-btn small flat outline style="border-color: grey; color: grey!important" @click="deleteStatement(props.item)" v-if="getCount(props.item) == 0">Delete</v-btn>
              </td>
            </template>
          </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
    
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  data: () =>({
    filterActive: false,
    nameRules: [
      v => !!v || 'SoW name is required'
    ],
    costRules: [
      v => !!v || 'Cost Calculcation Method is required'
    ],
    billingRules: [
      v => !!v || 'Billing Method is required'
    ],
    validation: true,
    search:'',
    isEdit: false,
    dialog: false,
    showLoading: false,
    selectedSoW: {},
    originalSoW: {},
    headers: [
      {text: 'Name', value: 'Name'},
      {text: 'Budgeted Days', value: 'Days'},
      {text: 'Consumed Days', value: '', sortable: false},
      {text: 'Description', value: 'Description'},
      {text: 'Billing Method', value: 'BillingMethod'},
      {text: 'Cost Calculation', value: 'CostCalculationMethod'},
      {text: 'Active', value: 'IsActive'},
      {text: 'Action', value: 'action', align: 'right'},
    ],
    consumedDays: []
  }),
  computed: {
    ...mapState('admin', ['statements', 'practices']),
    displayStatements: function() {
      return this.statements.filter(sow => sow.IsActive != this.filterActive)
    },
    projectLeads: function() {
      return this.pipefishUsers.map(user => ({text: `${user.GivenName} ${user.Surname}`, value: user}))
    }
  },
  created() {
    var self = this
    // get all SoW if they aren't already cached
    if(this.statements.length == 0) {
        this.$timesheetApi.getStatements().then(response => {
            self.setStatements(response)
        })
    }
    this.$timesheetApi.getConsumedDays().then(response => {
      self.consumedDays = response
    })

  },
  methods: {
    ...mapMutations('admin', ['setStatements']),
    ...mapMutations('api', ['setTimesheetData']),
    editStatement(sow) {
      this.isEdit = true
      this.showLoading = false
      Object.assign(this.selectedSoW, sow)
      this.dialog = true
    },
    addStatement() {
      this.$refs.form.resetValidation()
      this.showLoading = false
      this.isEdit = false
      this.dialog = true
      this.selectedSoW = {IsActive: true}
    },
    deleteStatement(item) {
      var self = this;
      this.$timesheetApi.deleteStatement(item.id).then(res => {
        self.$timesheetApi.getStatements().then(res => {
          self.setStatements(res);
          self.dialog = false;
        })
        self.$timesheetApi.getData().then(masterData => {
          self.setTimesheetData(masterData)
        })
      })
    },
    saveEdit() {
      this.showLoading = true
      var self = this
      if(this.isEdit) {
        // Editing an existing Sow
        this.$timesheetApi.updateStatement(this.selectedSoW).then(response => {
          // console.log(response)
          self.$timesheetApi.getStatements().then(res => {
            self.setStatements(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })

      } else {
        // Adding a new SoW
        // console.log(this.selectedSoW)
        this.$timesheetApi.addStatement(this.selectedSoW).then(response => {
          // console.log(response)
          self.$timesheetApi.getStatements().then(res => {
            self.setStatements(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })
      }
    },
    cancelEdit() {

      this.dialog = false
    },
    getCount(statement) {
      var found = this.consumedDays.find(count => {
        return count.StatementId == statement.id
      })
      return found ? found.sum/8 : 0
    }
  }

}
</script>

<style>

</style>
